import { render, staticRenderFns } from "./BaseBAccordion.vue?vue&type=template&id=af81b070&scoped=true"
import script from "./BaseBAccordion.vue?vue&type=script&lang=js"
export * from "./BaseBAccordion.vue?vue&type=script&lang=js"
import style0 from "./BaseBAccordion.vue?vue&type=style&index=0&id=af81b070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81b070",
  null
  
)

export default component.exports